// extracted by mini-css-extract-plugin
export default {"notification":"WithdrawalLimitToast_notification--cfX","closeIcon":"WithdrawalLimitToast_closeIcon--NEc"};